// localStorage keys owned by the dashboard feature.
// Versioned suffix allows breaking changes to column IDs without migration.
// Bumped v1 -> v2 when the 分野 (companySpecificIndustry) column was added, so a stale v1
// visibility set doesn't hide the new column from existing users.
export const MATCHING_RESULTS_MODAL_DISPLAY_COLUMNS_STORAGE_KEY = "matching-results-modal-display-columns:v2";
